import { Service } from '@/api/http-service';
import type { NovuControllerGetCredentialsResponse } from '@carvia/ros-client-types';

class NovuService extends Service {
  async getCredentials(): Promise<NovuControllerGetCredentialsResponse> {
    const response = await this.httpClient.get<NovuControllerGetCredentialsResponse>(
      `${this.endpoint}/credentials`,
    );
    return response.data;
  }
}

export const novuService = new NovuService('/novu');
